import React, {useEffect} from 'react';

import {authentication} from '../../../../shared/models/Authentication';
import {rwbApi} from '../../../../shared/apis/api';
import {useHistory} from 'react-router-dom';
import registerProfileFlow from '../../../../shared/utils/RegisterProfileFlow';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {userProfile} from '../../../../shared/models/UserProfile';

const Home = (props) => {
  let history = useHistory();

  useEffect(() => {
    authentication
      .getAccessToken()
      .then((accessToken) => {
        if (accessToken) return accessToken;
        return Promise.reject('Missing Credentials');
      })
      .then(rwbApi.getAuthenticatedUser)
      .then((json) => {
        const {email_verified, profile_completed, workspace} = json;
        if (!email_verified) {
          history.push(`/registration/confirm_email`);
        } else if (
          projectConfig.hasWorkspaces &&
          workspace == null &&
          !userProfile?.isOperator
        ) {
          history.push(`/registration/work_space`);
        } else if (email_verified && !profile_completed) {
          const firstScreen = registerProfileFlow.getFirstScreen();
          history.push(`/registration/${firstScreen.path}`);
        } else {
          history.push('/feed');
        }
      })
      .catch(() => {
        history.push('login');
      });
  }, [history]);

  return (
    <div style={{height: '100vh', display: 'none', justifyContent: 'center'}}>
      <div style={{marginTop: 60, padding: 40}}></div>
    </div>
  );
};

export default Home;
